module.exports = __webpack_public_path__ + "img/empty-bg.0fdddb36.svg";